import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab } from 'Core/components';
import CustomPropTypes from 'Core/prop-types';
import { AppModal } from '../components/app-modals';
import { showToast } from 'Core/redux/toast/slice';
import EditRobots from './edit-robots';
import RobotsDetailsForm from './robots-details-form';
import RobotsMaintenanceHistory from './robots-maintenance-history';
import CellHistory from './cell-history';
import SafetyChecklist from './safety-checklist';
import SafetyChecklistHistory from './safety-checklist-history';

const saveKeys = ['changed', 'id', 'isDeleted', 'userId'];
const editKeys = ['changed', 'isDeleted'];

const RobotsAddEdit = ({ showModal, modalData, onCloseModal }) => {
  console.log('RobotsAddEdit -> modalData:', modalData);
  const robotsData = modalData;
  const [formData, setFormData] = useState(robotsData || null);
  const [cellData, setCellData] = useState(null);
  const [safetyData, setSafetyData] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  console.log('RobotsAddEdit -> formData?.id:', formData?.id);
  console.log('RobotsAddEdit -> formData?.robotId:', formData?.robotId);

  const dispatch = useDispatch();
  const isEditMode = Boolean(robotsData?.id || robotsData?.assetNumber);

  const onChangesRobotsForm = data => {
    setFormData(data);
  };

  const onCellHistoryActionClick = (data, mode) => {
    setCellData({ data: data, mode: mode });
    setActiveTabIndex(1);
  };

  const onSafetyChecklistHistActionClick = (mode) => {
    setSafetyData({ mode: mode });
    setActiveTabIndex(3);
  };

  const handleTabChange = (newTabIndex) => {
    if (activeTabIndex === 1 && newTabIndex !== 1) {
      setCellData(null);
    }
    if (activeTabIndex === 5 && newTabIndex !== 5) {
      setSafetyData(null);
    }
    setActiveTabIndex(newTabIndex);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        {isEditMode && (
          <Tabs activeIndex={activeTabIndex} onTabChange={handleTabChange}>
            <Tab title="Edit Robot">
              <EditRobots
                data={formData}
                onChanges={onChangesRobotsForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Robot Maintenance Details">
              <RobotsDetailsForm
                data={formData}
                isEditMode={true}
                cellActionRecord={cellData}
                onChanges={onChangesRobotsForm}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Maintenance Records History">
              <RobotsMaintenanceHistory
                data={formData}
                robotId={formData?.robotId || formData?.id}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist">
              <SafetyChecklist
                robotId={formData?.robotId || formData?.id}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Cell History">
              <CellHistory
                assetNumber={formData?.assetNumber}
                onActionClick={onCellHistoryActionClick}
                onCloseModal={handleClose}
              />
            </Tab>
            <Tab title="Safety Checklist History">
              <SafetyChecklistHistory
                data={formData}
                onChanges={onChangesRobotsForm}
                onCloseModal={handleClose}
                robotId={formData?.robotId || formData?.id}
                onActionClick={onSafetyChecklistHistActionClick}
              />
            </Tab>
          </Tabs>
        )}
        {!isEditMode && (
          <EditRobots
            data={formData}
            onChanges={onChangesRobotsForm}
            onCloseModal={handleClose}
          />
        )}
      </div>
    );
  };

  const valid = () => {
    const ignoreKeys = isEditMode ? editKeys : saveKeys;
    if (
      !formData ||
      Object.keys(formData).some(key => {
        return !ignoreKeys.includes(key) && !formData[key];
      })
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  return (
    <Modal
      id="robots-modal"
      show={showModal}
      size="xl"
      title={isEditMode ? 'Robot Maintenance Summary' : 'Add Robot'}
      body={body}
      handleClose={handleClose}
    />
  );
};

RobotsAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Machines),
  onCloseModal: PropTypes.func,
};

export default AppModal(RobotsAddEdit);
